import { InvalidUrlError } from '../../errors/errors';
import { BaseGQLService } from '../../services/BaseGQLService';
import { ModelType } from '../../utils/GQLIdEncoder';
import { InventoryMapper } from '../mappers/InventoryMapper';
import { InventoryRecap } from '../models/InventoryRecap';

export const INVENTORY_QUERY_FRAGMENT = `
  algorithms {
    name
    lines {
      name
      count
      percentage
    }
  }
  keys {
    name
    lines {
      name
      count
      percentage
    }
  }
  keystores {
    name
    lines {
      name
      count
      percentage
    }
  }
  operations {
    name
    lines {
      name
      count
      percentage
    }
  }
`;

export const GET_PROJECT_INVENTORY_QUERY = `
query($id: ID!) {
  project: node(id: $id) {
    ... on Project {
      inventory {
        ${INVENTORY_QUERY_FRAGMENT}
      }
    }
  }
}
`;

export class InventoryService extends BaseGQLService {
  private readonly mapper = new InventoryMapper();

  async getProjectInventory(projectId: number): Promise<InventoryRecap | null> {
    return this.query(
      GET_PROJECT_INVENTORY_QUERY,
      {
        id: this.gqlIdEncoder.encode(ModelType.Project, projectId),
      },
      (data) => {
        if (!data.project) {
          throw new InvalidUrlError(`Invalid request: could not find Project ${projectId}`);
        }
        return this.mapper.mapGQLModel(data.project.inventory);
      }
    );
  }
}
